import React from "react";
import { cn } from "@/lib/utils";

/**
 * Soft radial-gradient blur used as a background accent.
 *
 * Props:
 *   color: "emerald" | "white" | custom rgba string
 *   size: px (default 480)
 *   intensity: 0..1 (default 0.35)
 *   animate: boolean (slow float) — default true
 */
export const GlowOrb = ({
  color = "emerald",
  size = 480,
  intensity = 0.35,
  animate = true,
  className,
  style,
  ...props
}) => {
  const rgba =
    color === "emerald"
      ? `rgba(0, 230, 118, ${intensity})`
      : color === "white"
        ? `rgba(255, 255, 255, ${intensity})`
        : color;

  return (
    <div
      aria-hidden="true"
      className={cn(
        "pointer-events-none absolute rounded-full blur-3xl",
        animate && "animate-float-slow",
        className,
      )}
      style={{
        width: size,
        height: size,
        background: `radial-gradient(circle, ${rgba} 0%, rgba(0,0,0,0) 65%)`,
        ...style,
      }}
      {...props}
    />
  );
};

export default GlowOrb;
